import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionTrabajadorCuentaPropiaByID from "services/record/DeclaracionTrabajadorCuentaPropia/useGetDeclaracionTrabajadorCuentaPropiaByID";
import useGetInfoDeclaracionTrabajadorCuentaPropia from "services/record/DeclaracionTrabajadorCuentaPropia/useGetInfoDeclaracionTrabajadorCuentaPropia";
import useGetDeclaracionTrabajadorCuentaPropiaByUser from "services/record/DeclaracionTrabajadorCuentaPropia/useGetDeclaracionTrabajadorCuentaPropiaByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionTrabajadorCuentaPropia from "./DeclaracionTrabajadorCuentaPropia";

const GridDeclaracionTrabajadorCuentaPropia = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionTrabajadorCuentaPropiaByID,
        loadingGetDeclaracionTrabajadorCuentaPropiaByID,
        statusGetDeclaracionTrabajadorCuentaPropiaByID
    } = useGetDeclaracionTrabajadorCuentaPropiaByID();

    const {
        getInfoDeclaracionTrabajadorCuentaPropia,
        loadingGetInfoDeclaracionTrabajadorCuentaPropia,
        statusGetInfoDeclaracionTrabajadorCuentaPropia
    } = useGetInfoDeclaracionTrabajadorCuentaPropia();

    const {
        dataGetDeclaracionTrabajadorCuentaPropiaByUser,
        getDeclaracionTrabajadorCuentaPropiaByUser,
        loadingGetDeclaracionTrabajadorCuentaPropiaByUser,
        statusGetDeclaracionTrabajadorCuentaPropiaByUser
    } = useGetDeclaracionTrabajadorCuentaPropiaByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración trabajador cuenta propia";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getDeclaracionTrabajadorCuentaPropiaByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetDeclaracionTrabajadorCuentaPropiaByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionTrabajadorCuentaPropiaByID.status,
                statusText: statusGetDeclaracionTrabajadorCuentaPropiaByID.statusText
            });
        } else if (statusGetInfoDeclaracionTrabajadorCuentaPropia?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionTrabajadorCuentaPropia.status,
                statusText: statusGetInfoDeclaracionTrabajadorCuentaPropia.statusText
            });
        } else if (statusGetDeclaracionTrabajadorCuentaPropiaByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionTrabajadorCuentaPropiaByUser.status,
                statusText: statusGetDeclaracionTrabajadorCuentaPropiaByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionTrabajadorCuentaPropiaByID,
        statusGetInfoDeclaracionTrabajadorCuentaPropia,
        statusGetDeclaracionTrabajadorCuentaPropiaByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionTrabajadorCuentaPropiaByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionTrabajadorCuentaPropia(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetDeclaracionTrabajadorCuentaPropiaByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionTrabajadorCuentaPropiaByUser]);

    const isLoading = () => {
        return (
            loadingGetDeclaracionTrabajadorCuentaPropiaByID ||
            loadingGetInfoDeclaracionTrabajadorCuentaPropia ||
            (loadingGetDeclaracionTrabajadorCuentaPropiaByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionTrabajadorCuentaPropiaByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionTrabajadorCuentaPropia
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionTrabajadorCuentaPropiaByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionTrabajadorCuentaPropia;
